import { store } from '../../index';
import { useHistory } from 'react-router-dom';
import { redirect } from '../actions/redirectActions';
import { startGame } from '../actions/socketActions';

import { foundGame } from '../actions/ingameActions';
import { gameStartListener } from '../../socketAPI/listeners';

//

const socketMiddleware = (socketClient) => (store) => (next) => (action) => {
	// console.log('dispatching', action);

	switch (action.type) {
		case 'CONNECT_SOCKET':
			socketClient
				.connect()
				.then((socket) => {
					console.log('successful socket connection');
					// check for existing game
					const roomId = localStorage.getItem('roomId');
					const socketId = localStorage.getItem('socketId');
					if (roomId && socketId)
						store.dispatch({ type: 'REJOIN_ROOM', roomId, socketId });

					console.log(socket);
					// write socket id to localStorage
					localStorage.setItem('socketId', socket.id);
				})
				.catch(() => {
					console.log('socket connection failed');
				});

			// start all listeners

			break; // very important

		case 'REJOIN_ROOM':
			socketClient
				.emit('rejoin-room', { roomId: action.roomId, socketId: action.socketId })
				.then((response) => {
					//
					console.log(response);
					gameStartListener(socketClient, response);
				})
				.catch((err) => console.log(err));
			break;

		case 'DISCONNECT_SOCKET':
			socketClient
				.disconnect()
				.then(() => {
					console.log('successful socket DISconnection');
				})
				.catch(() => {
					console.log('socket DISconnection failed');
				});
			break; // very important

		case 'JOIN_QUEUE':
			socketClient
				.emit('join-queue', action.queueOptions)
				.then((response) => {
					console.log(response);
					// redirect
					store.dispatch(redirect(response.mode));
					// dispatch action to start listeners for game
					store.dispatch(startGame());
					store.dispatch({ type: 'SET_ROOM_URL', value: response.roomURL });
				})
				.catch((err) => {
					console.log('something went wrong with join-queue.. ', err);
				});
			break;

		case 'LEAVE_GAME':
			const { ingame } = store.getState();

			socketClient
				.emit('leave-game', 'data')
				.then((res) => {
					console.log(res);
					store.dispatch(redirect(''));
					store.dispatch({ type: 'RESET_WHOLE_STATE' });

					// unset roomId
					localStorage.removeItem('roomId');
				})
				.catch((err) => {
					console.log(err);
				});
			break;
		// start listeners

		case 'START_GAME':
			// listen for game start and trigger ingame listeners once in game
			socketClient
				.on('game-start', (body) => {
					console.log(body);
					const { roomId } = body;
					// write game info into local storage
					localStorage.setItem('roomId', roomId);
					gameStartListener(socketClient, body);
				})
				.then(() => {
					console.log('resolved');
				})
				.catch((err) => {
					console.log(err);
				});

			break; // very important

		case 'PLAY_CARD':
			socketClient
				.emit('ingame', { type: 'play', body: action.card })
				.then(() => {
					console.log('sent play');
					console.log('sent play');
					console.log('sent play');
					console.log('sent play');
					console.log('sent play');
				})
				.catch((err) => {
					console.log(err);
				});
			break;

		case 'MAKE_BET':
			socketClient
				.emit('ingame', { type: 'make-bet', body: { bet: action.bet } })
				.then(() => {
					console.log('sent bet');
				})
				.catch((err) => {
					console.log(err);
				});

			break;

		case 'CHOOSE_TRUMPET':
			console.log(action);
			const suites = ['heart', 'nut', 'leave', 'bell'];
			const trumpet = suites.findIndex((elm) => elm === action.suite);
			console.log(trumpet);
			socketClient
				.emit('ingame', {
					type: 'choose-trumpet',
					body: { trumpet: trumpet },
				})
				.then(() => {
					console.log('sent trumpet');
				})
				.catch((err) => {
					console.log(err);
				});

			break;

		case 'CHEAT_VOTE':
			console.log('emmitting vote', action.value);
			socketClient.emit('ingame', {
				type: 'cheat-vote',
				body: { vote: action.value },
			});

			break;

		case 'test':
			console.log('case test reached');

			break; // very important
		default:
		//   Do something here
	}

	return next(action);
};

export default socketMiddleware;
